import { createFeature, createReducer, on } from '@ngrx/store';
import { AssetCategoryModel } from '@shared/data-access/models';
import { AssetCategoryAction } from '../actions';

export const featureName = 'assetCategory';

export interface AssetCategoryState {
  item: AssetCategoryModel | null;
}
export const initialState: AssetCategoryState = {
  item: null,
};
export const assetCategoryFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(AssetCategoryAction.loadItemSuccess, (state, prop: { item: AssetCategoryModel }) => ({ ...state, item: prop.item }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = assetCategoryFeature;
